// extracted by mini-css-extract-plugin
export default {"row":"_DXvzEUZhXJA0U4A1CHl","labelSum":"GHb4apTWDSaXzAn5MwYY","sumInfo":"t39SQCJJCEf58U6R0pNi","loading":"mqGzA6VaZ5XKHJNXssxI","placeHolderShimmer":"gMerWkl02PjiuaVnLcOO"};